export default __webpack_public_path__ + "static/media/littleclimbershb.138d29f2.png";